import { render, staticRenderFns } from "./BtnClone.vue?vue&type=template&id=158caeaa&scoped=true"
import script from "./BtnClone.vue?vue&type=script&lang=js"
export * from "./BtnClone.vue?vue&type=script&lang=js"
import style0 from "./BtnClone.vue?vue&type=style&index=0&id=158caeaa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "158caeaa",
  null
  
)

export default component.exports